import React from 'react';
import cl from './Cokie.module.css';

const Cokie = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Politica sui cookie per {props.shopName}</h1>

      <p>
      Questa è la Cookie Policy per {props.shopName}, accessibile da{' '}
        {props.domain}.com
      </p>

      <p>
        <strong>Cosa sono i cookie</strong>
      </p>

      <p>
      Come è prassi comune con quasi tutti i siti Web professionali, questo sito
         utilizza i cookie, che sono piccoli file che vengono scaricati sul tuo computer,
         per migliorare la tua esperienza Questa pagina descrive quali informazioni contengono
         raccogliere, come li utilizziamo e perché a volte abbiamo bisogno di memorizzare questi cookie.
         Condivideremo anche come impedire la memorizzazione di questi cookie
         tuttavia ciò potrebbe declassare o "interrompere" alcuni elementi dei siti
         funzionalità.
      </p>

      <p>
        <strong>Come utilizziamo i cookie</strong>
      </p>

      <p>
      Utilizziamo i cookie per una serie di motivi descritti di seguito. Purtroppo dentro
         nella maggior parte dei casi non esistono opzioni standard del settore per disabilitare i cookie
         senza disabilitare completamente le funzionalità e le caratteristiche a cui si aggiungono
         questo sito. Se lo sei, ti consigliamo di lasciare attivi tutti i cookie
         non sono sicuro se ne hai bisogno o meno nel caso in cui vengano utilizzati per fornire a
         servizio che utilizzi.
      </p>

      <p>
        <strong>Disabilitazione dei cookie</strong>
      </p>

      <p>
      Puoi impedire l'impostazione dei cookie modificando le impostazioni sul tuo
         browser (consulta la Guida del browser per sapere come eseguire questa operazione). Fai attenzione a
         la disabilitazione dei cookie influenzerà la funzionalità di questo e molti altri
         siti web che visiti. Di solito si ottiene anche la disattivazione dei cookie
         disabilitare determinate funzionalità e caratteristiche di questo sito. Perciò
         si consiglia di non disabilitare i cookie. Questa politica sui cookie
         è stato creato con l'aiuto di{' '}
        <a href="https://www.cookiepolicygenerator.com/cookie-policy-generator/">
        Generatore di politiche sui cookie
        </a>
        .
      </p>
      <p>
        <strong>I cookie che impostiamo</strong>
      </p>

      <ul>
        <li>
          <p>Cookie relativi all'elaborazione degli ordini</p>
          <p>
          Questo sito offre servizi di e-commerce o di pagamento e alcuni cookie
             sono essenziali per garantire che il tuo ordine venga ricordato tra le pagine
             in modo da poterlo elaborare correttamente.
          </p>
        </li>

        <li>
          <p>Cookie relativi ai sondaggi</p>
          <p>
          Di tanto in tanto offriamo sondaggi e questionari agli utenti
             fornirti spunti interessanti, strumenti utili o altro
             comprendere la nostra base utenti in modo più accurato. Questi sondaggi possono utilizzare
             cookie per ricordare chi ha già preso parte ad un sondaggio o per
             fornirti risultati accurati dopo aver cambiato pagina.
          </p>
        </li>

        <li>
          <p>Cookie relativi ai moduli</p>
          <p>
          Quando invii dati tramite un modulo come quelli presenti su
             pagine di contatto o moduli di commento i cookie possono essere impostati per ricordare i tuoi
             i dettagli dell'utente per la corrispondenza futura.
          </p>
        </li>

        <li>
          <p>Cookie delle preferenze del sito</p>
          <p>
          Per offrirti un'ottima esperienza su questo sito, noi
             fornire la funzionalità per impostare le tue preferenze su come funziona questo sito
             funziona quando lo usi. Per ricordare le tue preferenze abbiamo bisogno
             per impostare i cookie in modo che queste informazioni possano essere richiamate ogni volta che tu
             interagire con una pagina è influenzato dalle tue preferenze.
          </p>
        </li>
      </ul>

      <p>
        <strong>Cookie di terze parti</strong>
      </p>

      <p>
      In alcuni casi particolari utilizziamo anche cookie forniti da terzi di fiducia
         partiti. La sezione seguente descrive in dettaglio quali cookie di terze parti utilizzi
         potrebbero incontrare attraverso questo sito.
      </p>

      <ul>
        <li>
          <p>
          Di tanto in tanto testiamo nuove funzionalità e apportiamo piccole modifiche
             il modo in cui il sito viene consegnato. Quando stiamo ancora testando il nuovo
             caratteristiche questi cookie possono essere utilizzati per garantire che tu riceva un
             esperienza coerente mentre ci si trova sul sito, garantendo nel contempo noi
             capire quali ottimizzazioni i nostri utenti apprezzano di più.
          </p>
        </li>

        <li>
          <p>
          Poiché vendiamo prodotti, è importante per noi comprendere le statistiche
             su quanti visitatori del nostro sito effettivamente effettuano un acquisto
             e come tale questo è il tipo di dati che questi cookie tracceranno.
             Questo è importante per te perché significa che possiamo realizzarlo con precisione
             previsioni aziendali che ci consentono di monitorare la nostra pubblicità e
             costi del prodotto per garantire il miglior prezzo possibile.
          </p>
        </li>
      </ul>

      <p>
        <strong>Maggiori informazioni</strong>
      </p>

      <p>
      Spero che questo ti abbia chiarito le cose come è stato in precedenza
         menzionato se c'è qualcosa di cui non sei sicuro di aver bisogno o
         no, di solito è più sicuro lasciare i cookie abilitati nel caso in cui interagisca
         con una delle funzionalità che utilizzi sul nostro sito.
      </p>

      <p>
      Per informazioni più generali sui cookie, leggere{' '}
        <a href="https://www.cookiepolicygenerator.com/sample-cookies-policy/">
        l'articolo Cookie Policy
        </a>
        .
      </p>

      <p>
      Tuttavia, se stai ancora cercando ulteriori informazioni, puoi farlo
         contattaci attraverso uno dei nostri metodi di contatto preferiti:
      </p>

      <ul>
        <li>Email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Cokie;
